import { TransText } from '@/i18n/trans/text';
import { Divider, Icons, Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

interface TransferTimeProps {
  formattedTime: string | null;
  arrivalStation?: string;
  departureStation?: string;
  className?: string;
}

const TransferTime: FC<TransferTimeProps> = ({
  formattedTime,
  arrivalStation,
  departureStation,
}) => {
  const isSameStation = arrivalStation === departureStation;

  return (
    <div className="my-3 flex w-full flex-row items-center px-4">
      <Divider variant="medium" />
      <div className="flex flex-row items-center gap-4 px-2">
        <Typography
          variant="body2-bold"
          className="whitespace-nowrap text-neutral"
        >
          {formattedTime} <TransText i18nKey="transferTime" />
        </Typography>
        {!isSameStation && (
          <div className="flex flex-row gap-1.5">
            <Typography variant="body2">{arrivalStation}</Typography>
            <Icons.transfer className="text-neutral-light" />
            <Typography variant="body2">{departureStation}</Typography>
          </div>
        )}
      </div>
      <Divider variant="medium" />
    </div>
  );
};

export default TransferTime;
